let _ = require('lodash');
let moment = require('moment');
let { monkey } = require('baobab');
let utils = require('./utils');

module.exports = {
    selectChanged ({ optionsPath, selectedValue }, state) {
        let options = state.get(optionsPath);
        let oldSelectedValueIndex = _.findIndex(options, { isActive: true });
        if (oldSelectedValueIndex > -1) {
            state.set(optionsPath.concat(oldSelectedValueIndex).concat('isActive'), false);
        }
        let selectedIndex = _.findIndex(options, { value: selectedValue });
        if (selectedIndex > -1) {
            state.set(optionsPath.concat(selectedIndex).concat('isActive'), true);
        }
    },

    /**
     * Изменение месяца в дейтпикере
     */
    scrollPageDatepicker (path) {
        return function ({ toRight }, state) {
            sctollDatePickerInternal({ path, toRight }, state);
        };
    },

    scrollPageDatepickerBase (basePath) {
        return function ({ id, toRight }, state) {
            let path = basePath.concat(id).concat(['datepicker', 'calendar']);
            sctollDatePickerInternal({ path, toRight }, state);
        };
    },

    setDate (basePath) {
        return function ({ date, datepickerId }, state) {
            state.set(basePath.concat(datepickerId).concat(['datepicker', 'value']), date);
            state.set(['popups', 'active'], []);
        };
    },

    unsetDate (basePath) {
        return function ({ date, id }, state) {
            state.unset(basePath.concat(id).concat(['datepicker', 'value']), date);
        };
    },

    setDatePickerComputed (id, pathTo, pathFrom, state) {
        state.set(pathTo, monkey(
            pathFrom.concat('value'),
            pathFrom.concat('calendar'),
            pathFrom.concat('ui', 'isDisabled'),
            (selectedDate, calendar, isDisabled) => {
                let today = moment().subtract(1, 'day').unix();
                let till = moment().add(10, 'y').unix();
                let title = selectedDate ? moment.unix(selectedDate).format('DD.MM.YYYY') : '';
                let calendars = calendar ? calendar : [{ date: today }];

                return {
                    id: id,
                    mod: 'discounts',
                    withoutButton: true,
                    withInputs: false,
                    availableRange: {
                        from: moment({ year: 2000, month: 0 }).unix(),
                        till: till
                    },
                    calendars,
                    selectedDate,
                    title: { date: title },
                    isDisabled
                };
            }
        ));
    },

    togglePopup (args, state) {
        let name = `lead-required-field-${args.id}`;
        utils.togglePopupFromArgs({ name }, state);
    }
};

function sctollDatePickerInternal ({ path, toRight }, state) {
    let calendar = state.get(path);
    let date = calendar ? moment.unix(_.first(calendar).date) : moment().day(1);

    if (toRight) {
        date.add(1, 'month');
    } else {
        date.subtract(1, 'month');
    }
    state.set(path, [{ date: date.unix() }]);
}



// WEBPACK FOOTER //
// ./actions/accountUi.js